import { render, staticRenderFns } from "./ClientChatSharePopUp.vue?vue&type=template&id=7117bfa0&scoped=true&"
import script from "./ClientChatSharePopUp.vue?vue&type=script&lang=js&"
export * from "./ClientChatSharePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117bfa0",
  null
  
)

export default component.exports